var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.621,
    height: 19.219,
    viewBox: "0 0 19.621 19.219",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_350",
    "data-name": "Groupe 350",
    transform: "translate(-270.991 -365.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_509",
    "data-name": "Trac\\xE9 509",
    d: "M277.847,374.285l-6.729,6.813a.445.445,0,0,0-.127.311v3.3a.442.442,0,0,0,.442.442h5.195a.442.442,0,0,0,.442-.442v-2.216a.442.442,0,0,1,.442-.442H279.1a.442.442,0,0,0,.442-.442v-1.487a.442.442,0,0,1,.442-.442h1.8a.441.441,0,0,0,.312-.13l.768-.768a.442.442,0,0,0-.02-.644l-4.389-3.875A.442.442,0,0,0,277.847,374.285Z",
    fill: "#12162c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_504",
    "data-name": "Trac\\xE9 504",
    d: "M284.112,365.933a6.5,6.5,0,1,0,6.5,6.5A6.5,6.5,0,0,0,284.112,365.933Zm1.916,6.5a1.916,1.916,0,1,1,1.916-1.916A1.916,1.916,0,0,1,286.028,372.433Z",
    fill: "#12162c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.503a3d7ef15f9c563efaa6b583e569bf.svg";
export { ForwardRef as ReactComponent };